import WithRender from "../../templates/layouts/layoutPacking.html";
import { mapGetters } from "vuex";
import { i18n } from "../../i18n.js";

export default WithRender({
  computed: {
    ...mapGetters(["getAddToCartFullPage", "getForceDisablePersonalization"])
  },
  methods: {
    getContainerLabel: function (idx) {
      if (idx == 1) {
        return i18n.t("1. Composition");
      } else if (idx == 2) {
        return i18n.t("2. Dimensions");
      } else if (idx == 3) {
        return i18n.t("3. Impression");
      } else if (idx == 4) {
        return i18n.t("4. Options");
      } else if (idx == 5) {
        return i18n.t("5. Choose quantity");
      }
      return "";
    }
  }
});
